const ADMIN_DEBUG_KEY = 'admin_debug'
const LOG_PREFIX = '[Showoff User]'

function isAdminDebug(): boolean {
  try {
    return localStorage.getItem(ADMIN_DEBUG_KEY) === 'true'
  } catch {
    return false
  }
}

/**
 * Логирование состояния пользователя в консоль DevTools.
 * Включается только при localStorage.admin_debug === 'true'.
 * На проде можно включить в консоли: localStorage.setItem('admin_debug', 'true')
 */
export function logUser(message: string, data?: object): void {
  if (!isAdminDebug()) return
  if (data !== undefined) {
    console.info(LOG_PREFIX, message, data)
  } else {
    console.info(LOG_PREFIX, message)
  }
}
